export default function AssessmentFactorDirective() {
  return {
    template: require('./assessment-factor.html'),
    scope: {
      maturityDomainId: '=',
      assessmentFactor: '=',
      isEdit: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'AssessmentFactorController',
    controllerAs: 'assessmentFactorVM',
    bindToController: true,
    replace: true
  };
}
